if (!customElements.get('collapsible-tab')) {
	class SizeFilter {
		constructor(collapsibleTab) {
			this.tab = collapsibleTab
			this.contentInner = this.tab.querySelector('.collapsible__content-inner')
			this.unsubscribers = []
			this.onVariantChangedListener = null
			if (!this.contentInner) return

			this.init()
		}

		init() {
			this.prepareContent()

			const productInfo = this.tab.closest('product-info') || document

			// 1. Listen for DOM custom event "variant:changed"
			this.onVariantChangedListener = (evt) => {
				this.filterContent(productInfo)
			}
			document.addEventListener('variant:changed', this.onVariantChangedListener)

			// 2. Listen for theme pub/sub events
			if (window.FoxThemeEvents) {
				const unsubVariantChange = window.FoxThemeEvents.subscribe('variant-change', () => {
					setTimeout(() => this.filterContent(productInfo), 0)
				})
				const unsubOptionChange = window.FoxThemeEvents.subscribe('option-value-selection-change', () => {
					setTimeout(() => this.filterContent(productInfo), 0)
				})
				this.unsubscribers.push(unsubVariantChange, unsubOptionChange)
			}

			// 3. Initial filter
			this.filterContent(productInfo)
		}

		prepareContent() {
			const container = this.contentInner
			if (container.dataset.sizeFilterPrepared === 'true') return
			container.dataset.sizeFilterPrepared = 'true'

			const readMoreContent = container.querySelector('.read-more-lines__content')
			const targetContainer = readMoreContent || container

			// 1. Run splitByBr on targetContainer itself
			this.splitByBr(targetContainer)

			// 2. Run splitByBr on any paragraph, list item, or div inside targetContainer
			targetContainer.querySelectorAll('p, li, div').forEach(el => {
				if (!el.classList.contains('collapsible-filter-item')) {
					this.splitByBr(el)
				}
			})
		}

		splitByBr(element) {
			const childNodes = Array.from(element.childNodes)
			const hasBr = childNodes.some(node => node.nodeName === 'BR')
			if (!hasBr) return

			const newChildren = []
			let currentGroup = []

			for (const node of childNodes) {
				if (node.nodeName === 'BR') {
					if (currentGroup.length > 0) {
						const tempSpan = document.createElement('span')
						currentGroup.forEach(n => tempSpan.appendChild(n))
						if (tempSpan.textContent.trim().length > 0) {
							tempSpan.className = 'collapsible-filter-item'
							tempSpan.style.display = 'block'
							newChildren.push(tempSpan)
						}
						currentGroup = []
					}
				} else {
					currentGroup.push(node)
				}
			}

			if (currentGroup.length > 0) {
				const tempSpan = document.createElement('span')
				currentGroup.forEach(n => tempSpan.appendChild(n))
				if (tempSpan.textContent.trim().length > 0) {
					tempSpan.className = 'collapsible-filter-item'
					tempSpan.style.display = 'block'
					newChildren.push(tempSpan)
				}
			}

			element.innerHTML = ''
			newChildren.forEach(child => element.appendChild(child))
		}

		getFilterableItems(targetContainer) {
			const items = []
			
			// 1. Find all elements that are explicitly marked as filter items
			const explicitItems = targetContainer.querySelectorAll('.collapsible-filter-item')
			explicitItems.forEach(item => items.push(item))

			// 2. Find all block elements (p, li, h1-h6) that do not contain any .collapsible-filter-item
			const blocks = targetContainer.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6')
			blocks.forEach(block => {
				if (!block.querySelector('.collapsible-filter-item')) {
					const hasBlockChild = block.querySelector('p, li, h1, h2, h3, h4, h5, h6')
					if (!hasBlockChild && !block.classList.contains('collapsible-filter-item')) {
						items.push(block)
					}
				}
			})

			return items
		}

		filterContent(productInfo) {
			const sizeField = productInfo.querySelector(
				'.variant-picker__field[data-option-name="Size"], ' +
				'.variant-picker__field[data-option-name="size"], ' +
				'.variant-picker__field[data-option-name*="size" i]'
			)
			if (!sizeField) return

			let selectedSize = null
			const select = sizeField.querySelector('select')
			if (select) {
				selectedSize = select.value
			} else {
				const checkedRadio = sizeField.querySelector('input[type="radio"]:checked')
				if (checkedRadio) {
					selectedSize = checkedRadio.value
				}
			}

			if (!selectedSize) {
				const activeOption = sizeField.querySelector('.variant-picker__option-button.is-active, .variant-picker__option-button.active, [aria-checked="true"]')
				if (activeOption) {
					selectedSize = activeOption.dataset.value || activeOption.textContent.trim()
				}
			}

			if (!selectedSize) return

			let allSizes = []
			if (select) {
				allSizes = Array.from(select.options).map(opt => opt.value)
			} else {
				const radios = sizeField.querySelectorAll('input[type="radio"]')
				if (radios.length > 0) {
					allSizes = Array.from(radios).map(radio => radio.value)
				} else {
					const buttons = sizeField.querySelectorAll('.variant-picker__option-button')
					allSizes = Array.from(buttons).map(btn => btn.dataset.value || btn.textContent.trim())
				}
			}

			if (allSizes.length === 0) return

			const sizeMappings = {
				's': ['small', 's'],
				'm': ['medium', 'm'],
				'l': ['large', 'l'],
				'xl': ['extra large', 'xl'],
				'xs': ['extra small', 'xs'],
				'xxl': ['double extra large', 'xxl', '2xl'],
				'xxxl': ['triple extra large', 'xxxl', '3xl']
			}

			function getSizeTerms(sizeName) {
				const lower = sizeName.toLowerCase().trim()
				for (const key in sizeMappings) {
					if (sizeMappings[key].includes(lower)) {
						return sizeMappings[key]
					}
				}
				return [lower]
			}

			function matchTerm(text, term) {
				const escaped = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
				const regex = new RegExp('\\b' + escaped + '\\b', 'i')
				return regex.test(text)
			}

			const otherSizes = allSizes.filter(s => s.toLowerCase().trim() !== selectedSize.toLowerCase().trim())
			const excludedTerms = []
			otherSizes.forEach(size => {
				getSizeTerms(size).forEach(term => {
					if (!excludedTerms.includes(term)) {
						excludedTerms.push(term)
					}
				})
			})

			const selectedTerms = getSizeTerms(selectedSize)

			const readMoreContent = this.contentInner.querySelector('.read-more-lines__content')
			const targetContainer = readMoreContent || this.contentInner
			const items = this.getFilterableItems(targetContainer)

			items.forEach(item => {
				const text = item.textContent.trim()
				
				let hasExcluded = false
				for (const term of excludedTerms) {
					if (matchTerm(text, term)) {
						hasExcluded = true
						break
					}
				}

				let hasSelected = false
				for (const term of selectedTerms) {
					if (matchTerm(text, term)) {
						hasSelected = true
						break
					}
				}

				if (hasExcluded && !hasSelected) {
					item.style.display = 'none'
				} else {
					if (item.classList.contains('collapsible-filter-item') && item.tagName === 'SPAN') {
						item.style.display = 'block'
					} else {
						item.style.display = ''
					}
				}
			})

			if (this.tab.selected || this.tab.classList.contains('is-expanded')) {
				const content = this.tab.querySelector('[data-content]')
				if (content) {
					content.style.height = content.scrollHeight + "px"
				}
			}
		}

		destroy() {
			if (this.onVariantChangedListener) {
				document.removeEventListener('variant:changed', this.onVariantChangedListener)
			}
			this.unsubscribers.forEach(unsub => {
				if (typeof unsub === 'function') {
					unsub()
				}
			})
			this.unsubscribers = []
		}
	}

	class CollapsibleTab extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.init()
		}

		disconnectedCallback() {
			this.destroy()
		}

		init() {
			const destroy = this.dataset.destroy === 'true'
			if (destroy) return

			this.setDefaultData();
			this.attachEvents()

			if (this.getAttribute('open') === 'true') {
				this.selected = true
				this.classList.add(this.expandedClass, this.selectedClass)
				this.setExpandedAria()
				this.fire("tabOpened")
				window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
			} else {
				this.content.style.height = this.collapsedHeight
				this.classList.add(this.collapsedClass)
				this.setCollapsedAria()
			}
			this.content.removeAttribute('hidden')

			if (this.dataset.filterBySize === 'true') {
				this.sizeFilter = new SizeFilter(this)
			}
		}

		transitionendEventName() {
			let i,
				el = document.createElement('div'),
				transitions = {
					'transition': 'transitionend',
					'OTransition': 'otransitionend',
					'MozTransition': 'transitionend',
					'WebkitTransition': 'webkitTransitionEnd'
				}

			for (i in transitions) {
				if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
					return transitions[i]
				}
			}
		}

		expand() {
			const resetHeight = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (!this.isOpen) return

				requestAnimationFrame(() => {
					this.content.style.transition = '0'
					this.content.style.height = 'auto'

					requestAnimationFrame(() => {
						this.content.style.height = null
						this.content.style.transition = null

						this.setExpandedAria()
						this.classList.add(this.expandedClass)
						this.trySetTabIndex(this.content, 0)

						this.fire("tabOpened")
						window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
					})
				})
			}

			const bindEvent = resetHeight.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = true
			this.classList.remove(this.collapsedClass)
			this.content.style.height = this.content.scrollHeight + "px"
		}

		collapse() {
			const endTransition = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (this.isOpen) return

				this.fire("elementClosed")
				window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this)
				this.setCollapsedAria()
				this.classList.add(this.collapsedClass)
				this.trySetTabIndex(this.content, -1)
			}

			const bindEvent = endTransition.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = false
			this.classList.remove(this.expandedClass)

			requestAnimationFrame(() => {
				this.content.style.transition = '0'
				this.content.style.height = this.content.scrollHeight + "px"


				requestAnimationFrame(() => {
					this.content.style.transition = null
					this.content.style.height = this.collapsedHeight
				})
			})
		}

		open() {
			this.selected = true
			this.classList.add(this.selectedClass)
			this.fire("elementSelected")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this)
			this.expand()
			this.setAttribute('open', true)

			if (this.oneAtATime) {
				const parent = this.closest('[data-collapsible-parent]')
				if( parent ) {
					const allItems = parent.querySelectorAll('collapsible-tab')
					if (allItems.length) {
						allItems.forEach(item => {
							if (item !== this && item.selected) {
								item.close()
							}
						})
					}
				}
			}
		}

		close() {
			this.selected = false
			this.classList.remove(this.selectedClass)
			this.fire("elementUnselected")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this)
			this.collapse()
			this.removeAttribute('open')
		}

		toggle(event) {
			if(event) {
				event.preventDefault()
			}

			if (this.selected) {
				if ( this.canCloseAll ) {
					this.close()
				} else {
					const parent = this.closest('[data-collapsible-parent]')
					if( parent ) {
						const allItems = parent.querySelectorAll('collapsible-tab')
						allItems.forEach(item => {
							if (item !== this && item.selected) { // If has other selected then close this.
								this.close()
								return true
							}
						})
					}
				}
			} else {
				this.open()
			}
		}

		trySetTabIndex(el, index) {
			const tappableElements = el.querySelectorAll(this.defaultElements)
			if (tappableElements) {
				tappableElements.forEach(e => {
					e.setAttribute('tabindex', index)
				})
			}
		}

		setExpandedAria() {
			this.trigger.setAttribute('aria-expanded', 'true')
			this.content.setAttribute('aria-hidden', 'false')
		}

		setCollapsedAria(el) {
			this.trigger.setAttribute('aria-expanded', 'false')
			this.content.setAttribute('aria-hidden', 'true')
		}

		attachEvents() {
			this.trigger.addEventListener("click", event => this.toggle(event))
		}

		setDefaultData() {
			this.events = {
				'elementSelected': [],
				'tabOpened': [],
				'elementUnselected': [],
				'elementClosed': []
			}
			this.transitionendevent = this.transitionendEventName()
			this.expandedClass = "is-expanded"
			this.selectedClass = "is-selected"
			this.collapsedClass = "is-collapsed"
			this.trigger = this.querySelector('[data-trigger]')
			this.content = this.querySelector('[data-content]')
			this.collapsedHeight = '0px'
			this.defaultElements = ['a', 'button', 'input:not(.focus-none)', '[data-trigger]']
			this.oneAtATime = true
			if (this.dataset.oneOpen) {
				this.oneAtATime = this.dataset.oneOpen === 'true'
			}

			// Whether keep at least an item opened.
			this.canCloseAll = ( ! this.dataset.canCloseAll || this.dataset.canCloseAll === 'true' )
		}

		fire(eventName) {
			let callbacks = this.events[eventName] || []
			for (let i = 0; i < callbacks.length; i++) {
				callbacks[i](this)
			}
		}

		on(eventName, cb) {
			if (!this.events[eventName]) return
			this.events[eventName].push(cb)
		}

		destroy() {
			this.trigger && this.trigger.removeEventListener("click", event => this.toggle(event))
			this.content && this.content.removeAttribute('aria-hidden')
			if (this.content) this.content.style.height = 'auto'
			this.classList.remove(this.expandedClass, this.collapsedClass)
			this.removeAttribute('open')
			if (this.sizeFilter) {
				this.sizeFilter.destroy()
				this.sizeFilter = null
			}
		}
	}

	customElements.define('collapsible-tab', CollapsibleTab)
}
